(function( $, doc ) {
    "use strict";

    (function(){

        // OPEN Modal
        $(document).on("click", ".wpmudev-open-modal", function(e){

            e.preventDefault();
            e.stopPropagation();
            
            var $this = $(this),
                $modal_id = $this.data('modal'),
                $modal = $("#forminator-modal-" + $modal_id),
                $content = $modal.find(".wpmudev-box-modal")
            ;

            $modal.addClass("wpmudev-modal-active");
            $("body").addClass("wpmudev-modal-is_active");

            setTimeout(function(){
                $content.addClass("wpmudev-show");
            });
            
        });
        
        // CLOSE Modal
        $(document).on("click", ".wpmudev-i_close", function(e){

            e.preventDefault();
            e.stopPropagation();

			var $modal = $(this).closest('.wpmudev-modal'),
				$content = $modal.find(".wpmudev-box-modal");

            $content.removeClass('wpmudev-show').addClass('wpmudev-hide');

            setTimeout(function(){
                $modal.removeClass('wpmudev-modal-active');
                $('body').removeClass('wpmudev-modal-is_active');
                $content.removeClass('wpmudev-hide');
            }, 1000);
            
        });

        // Custom Forms
        // WRAP every three layouts
        $("#forminator-modal-dashboard-popup-custom-form").ready(function(){
            
            var $this = $("#forminator-modal-dashboard-popup-custom-form"),
                $box = $this.find(".forminator-box-type");

            for(var i = 0; i < $box.length; i+=3) {
                $box.slice(i, i+3).wrapAll("<div class='forminator-row'></div>");
            }
            
        });

    }());

}( jQuery, document ));